"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var antd_1 = require("antd");
var collectionsRef_1 = require("common/db/collectionsRef");
var usersList_1 = require("common/global/usersList");
var draft_js_1 = require("draft-js");
var draft_js_buttons_1 = require("draft-js-buttons");
var draft_js_emoji_plugin_1 = __importDefault(require("draft-js-emoji-plugin"));
require("draft-js-emoji-plugin/lib/plugin.css");
var draft_js_export_html_1 = require("draft-js-export-html");
var draft_js_linkify_plugin_1 = __importDefault(require("draft-js-linkify-plugin"));
require("draft-js-linkify-plugin/lib/plugin.css");
var draft_js_mention_plugin_1 = __importStar(require("draft-js-mention-plugin"));
var draft_js_plugins_editor_1 = __importDefault(require("draft-js-plugins-editor"));
var draft_js_static_toolbar_plugin_1 = __importStar(require("draft-js-static-toolbar-plugin"));
require("draft-js-static-toolbar-plugin/lib/plugin.css");
var app_1 = __importDefault(require("firebase/app"));
var lodash_1 = require("lodash");
var react_1 = __importStar(require("react"));
var react_i18next_1 = require("react-i18next");
var editorStyles_css_1 = __importDefault(require("./editorStyles.css"));
var mentionsStyles_css_1 = __importDefault(require("./mentionsStyles.css"));
var Post_1 = __importDefault(require("./Post"));
var reduxHooks_1 = require("portal/hooks/reduxHooks");
function Draft(props) {
    var _this = this;
    var t = (0, react_i18next_1.useTranslation)().t;
    var _a = (0, react_1.useState)(false), loading = _a[0], setLoading = _a[1];
    var currentUser = (0, reduxHooks_1.useAppSelector)(function (state) { return state.auth; }).currentUser;
    var kind = props.kind, docId = props.docId, viewInput = props.viewInput;
    var emojiPlugin = (0, react_1.useMemo)(function () { return (0, draft_js_emoji_plugin_1.default)(); }, []);
    var EmojiSuggestions = emojiPlugin.EmojiSuggestions;
    var _b = (0, react_1.useState)(draft_js_1.EditorState.createWithContent(draft_js_1.ContentState.createFromText(""))), editorState = _b[0], setEditorState = _b[1];
    var editorRef = (0, react_1.useRef)(null);
    var createdAt = app_1.default.firestore.Timestamp.fromDate(new Date());
    var usersMentions = (0, react_1.useMemo)(function () {
        return (0, lodash_1.map)(usersList_1.globalUsersData, function (e) { return ({
            key: e.id,
            name: e.name,
            title: e.jobTitle,
        }); });
    }, []);
    var _c = (0, react_1.useState)(usersMentions), suggestions = _c[0], setSuggestions = _c[1];
    var mentionPlugin = (0, react_1.useMemo)(function () {
        return (0, draft_js_mention_plugin_1.default)({
            mentions: usersMentions,
            entityMutability: "IMMUTABLE",
            theme: mentionsStyles_css_1.default,
            positionSuggestions: positionSuggestions,
            mentionPrefix: "@",
            supportWhitespace: true,
        });
    }, [usersMentions]);
    var toolbarPlugin = (0, react_1.useMemo)(function () { return (0, draft_js_static_toolbar_plugin_1.default)(); }, []);
    var Toolbar = toolbarPlugin.Toolbar;
    var MentionSuggestions = mentionPlugin.MentionSuggestions;
    var linkifyPlugin = (0, react_1.useMemo)(function () { return (0, draft_js_linkify_plugin_1.default)(); }, []);
    var plugins = (0, react_1.useMemo)(function () { return [mentionPlugin, emojiPlugin, toolbarPlugin, linkifyPlugin]; }, [mentionPlugin, emojiPlugin, toolbarPlugin, linkifyPlugin]);
    function onSearchChange(_a) {
        var value = _a.value;
        setSuggestions((0, draft_js_mention_plugin_1.defaultSuggestionsFilter)(value, usersMentions));
    }
    var buttonsProps = {
        getEditorState: function () { return editorState; },
        setEditorState: setEditorState,
    };
    var html = (0, draft_js_export_html_1.stateToHTML)(editorState.getCurrentContent());
    return ((0, jsx_runtime_1.jsxs)("div", { children: [viewInput ? ((0, jsx_runtime_1.jsxs)("div", __assign({ className: editorStyles_css_1.default.editor, onClick: function () {
                    var _a;
                    (_a = editorRef.current) === null || _a === void 0 ? void 0 : _a.focus();
                } }, { children: [(0, jsx_runtime_1.jsx)(Toolbar, __assign({ className: editorStyles_css_1.default.toolbar }, { children: function (externalProps) { return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(draft_js_buttons_1.BoldButton, __assign({}, externalProps, buttonsProps)), (0, jsx_runtime_1.jsx)(draft_js_buttons_1.ItalicButton, __assign({}, externalProps, buttonsProps)), (0, jsx_runtime_1.jsx)(draft_js_buttons_1.UnderlineButton, __assign({}, externalProps, buttonsProps)), (0, jsx_runtime_1.jsx)(draft_js_buttons_1.CodeButton, __assign({}, externalProps, buttonsProps)), (0, jsx_runtime_1.jsx)(draft_js_static_toolbar_plugin_1.Separator, __assign({}, externalProps, buttonsProps)), (0, jsx_runtime_1.jsx)(draft_js_buttons_1.HeadlineOneButton, __assign({}, externalProps, buttonsProps)), (0, jsx_runtime_1.jsx)(draft_js_buttons_1.HeadlineTwoButton, __assign({}, externalProps, buttonsProps)), (0, jsx_runtime_1.jsx)(draft_js_buttons_1.HeadlineThreeButton, __assign({}, externalProps, buttonsProps)), (0, jsx_runtime_1.jsx)(draft_js_buttons_1.UnorderedListButton, __assign({}, externalProps, buttonsProps)), (0, jsx_runtime_1.jsx)(draft_js_buttons_1.OrderedListButton, __assign({}, externalProps, buttonsProps)), (0, jsx_runtime_1.jsx)(draft_js_buttons_1.BlockquoteButton, __assign({}, externalProps, buttonsProps)), (0, jsx_runtime_1.jsx)(draft_js_buttons_1.CodeBlockButton, __assign({}, externalProps, buttonsProps))] })); } })), (0, jsx_runtime_1.jsx)("div", __assign({ className: editorStyles_css_1.default.innerEditor }, { children: (0, jsx_runtime_1.jsx)(draft_js_plugins_editor_1.default, { placeholder: t("discussion.typeYourComment"), editorState: editorState, onChange: setEditorState, plugins: plugins, ref: function (element) {
                                editorRef.current = element;
                            } }) })), (0, jsx_runtime_1.jsx)(MentionSuggestions, { onSearchChange: onSearchChange, suggestions: suggestions, entryComponent: Entry }), (0, jsx_runtime_1.jsx)(EmojiSuggestions, {}), (0, jsx_runtime_1.jsx)(antd_1.Button, __assign({ className: editorStyles_css_1.default.button, loading: loading, type: "primary", onClick: function () { return __awaiter(_this, void 0, void 0, function () {
                            var usersMentioned, e_1;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        _a.trys.push([0, 3, 4, 5]);
                                        setLoading(true);
                                        return [4 /*yield*/, collectionsRef_1.discussionsRef.add({
                                                documentType: kind,
                                                body: html,
                                                createdAt: createdAt,
                                                documentId: docId,
                                                userId: currentUser.id,
                                            })];
                                    case 1:
                                        _a.sent();
                                        usersMentioned = (0, lodash_1.uniq)(getEntities(editorState, "mention").map(function (x) { return x.entity.data.mention.key; }));
                                        return [4 /*yield*/, Promise.all(usersMentioned.map(function (e) {
                                                return collectionsRef_1.notificationsRef.add({
                                                    userId: e,
                                                    action: "mention",
                                                    createdAt: new Date(),
                                                    docId: docId,
                                                    docType: kind,
                                                    content: html,
                                                    byUserId: currentUser.id,
                                                    read: false,
                                                });
                                            }))];
                                    case 2:
                                        _a.sent();
                                        setEditorState(draft_js_1.EditorState.createWithContent(draft_js_1.ContentState.createFromText("")));
                                        antd_1.message.success(t("alerts.success"));
                                        return [3 /*break*/, 5];
                                    case 3:
                                        e_1 = _a.sent();
                                        console.error(e_1);
                                        antd_1.message.error(t("alerts.error"));
                                        return [3 /*break*/, 5];
                                    case 4:
                                        setLoading(false);
                                        return [7 /*endfinally*/];
                                    case 5: return [2 /*return*/];
                                }
                            });
                        }); } }, { children: t("common.send") }))] }))) : null, (0, jsx_runtime_1.jsx)("div", __assign({ className: editorStyles_css_1.default.options }, { children: (0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsx)(Post_1.default, { docId: docId, documentType: kind, style: editorStyles_css_1.default.post }) }) }))] }));
}
exports.default = Draft;
var getEntities = function (editorState, entityType) {
    if (entityType === void 0) { entityType = null; }
    var content = editorState.getCurrentContent();
    var entities = [];
    content.getBlocksAsArray().forEach(function (block) {
        var selectedEntity = null;
        block.findEntityRanges(function (character) {
            if (character.getEntity() !== null) {
                var entity = content.getEntity(character.getEntity());
                if (!entityType || (entityType && entity.getType() === entityType)) {
                    selectedEntity = {
                        entityKey: character.getEntity(),
                        blockKey: block.getKey(),
                        entity: content.getEntity(character.getEntity()),
                    };
                    return true;
                }
            }
            return false;
        }, function (start, end) {
            entities.push(__assign(__assign({}, selectedEntity), { start: start, end: end }));
        });
    });
    return entities;
};
function positionSuggestions(_a) {
    var state = _a.state, props = _a.props;
    var transform;
    var transition;
    if (state.isActive && props.suggestions.length > 0) {
        transform = "scaleY(1)";
        transition = "all 0.25s cubic-bezier(.3,1.2,.2,1)";
    }
    else if (state.isActive) {
        transform = "scaleY(0)";
        transition = "all 0.25s cubic-bezier(.3,1,.2,1)";
    }
    return {
        transform: transform,
        transition: transition,
    };
}
function Entry(props) {
    var mention = props.mention, theme = props.theme, parentProps = __rest(props, ["mention", "theme"]);
    return ((0, jsx_runtime_1.jsx)("div", __assign({}, parentProps, { children: (0, jsx_runtime_1.jsxs)("div", __assign({ className: theme.mentionSuggestionsEntryContainer }, { children: [(0, jsx_runtime_1.jsx)("div", __assign({ className: theme.mentionSuggestionsEntryContainerLeft }, { children: (0, jsx_runtime_1.jsx)("img", { src: mention.avatar, className: theme.mentionSuggestionsEntryAvatar, role: "presentation", alt: mention.name }) })), (0, jsx_runtime_1.jsxs)("div", __assign({ className: theme.mentionSuggestionsEntryContainerRight }, { children: [(0, jsx_runtime_1.jsx)("div", __assign({ className: theme.mentionSuggestionsEntryText }, { children: mention.name })), (0, jsx_runtime_1.jsx)("div", __assign({ className: theme.mentionSuggestionsEntryTitle }, { children: mention.title }))] }))] })) })));
}
